export const textInCapitalCase = (text) => {
  if (!text?.length) return '';
  const firstLetter = text.charAt(0).toUpperCase();
  const nextLetters = text.slice(1).toLowerCase();
  return `${firstLetter}${nextLetters}`;
};

export const removeLettersAfterCharacter = (text, character) =>
  text.split(character)[0];

export const cleanTextForBackButton = (text) => {
  if (!text) return '';
  if (text === text?.toUpperCase()) return ` ${text.toLowerCase()}`;
  return text?.replace(/\/|-/gi, ' ');
};
